import React from 'react'
import styled from 'styled-components'

const Separator = styled.div`
  border-bottom: 1px solid #c3c3c3;
  margin: 30px auto;
  width: 90%;
`

export default Separator



// WEBPACK FOOTER //
// ./src/components/separator.js